
const REFRESH_COOLDOWN_MS = 5000;

export default {
  created() {
    this._focusRefreshLast = 0;
    this._focusRefreshHandler = () => {
      if (document.visibilityState === 'hidden') return;
      const now = Date.now();
      if (now - this._focusRefreshLast < REFRESH_COOLDOWN_MS) return;
      this._focusRefreshLast = now;
      if (typeof this.onFocusRefresh === 'function') this.onFocusRefresh();
    };
  },
  mounted() {
    window.addEventListener('focus', this._focusRefreshHandler);
    document.addEventListener('visibilitychange', this._focusRefreshHandler);
  },
  beforeDestroy() {
    window.removeEventListener('focus', this._focusRefreshHandler);
    document.removeEventListener('visibilitychange', this._focusRefreshHandler);
  },
};
